import Paper from "@material-ui/core/Paper";
import Button from "../../Buttons/Button";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./DetailsView.scss";

const DetailsView = ({ children, heading, onSubmit, onCancel, isDisabled }) => {
  const { t } = useTranslation();
  return (
    <Paper className="details__view__paper__container">
      <div className="details__view__header"> {t(heading)}</div>
      <div className="details__view__body">{children}</div>
      <div className="details__view__footer">
        <div className="details__view__footer__buttons">
          <Button
            variant="outlined"
            className={`${
              !isDisabled ? "details__view__footer__buttons--submit" : ""
            } `}
            onClick={onSubmit}
            disabled={isDisabled}
            aria-label="submit"
          >
            {t(`Submit`)}
          </Button>
          <Button
            variant="outlined"
            className="details__view__footer__buttons--cancel"
            onClick={onCancel}
            aria-label="cancel"
          >
            {t(`Cancel`)}
          </Button>
        </div>
      </div>
    </Paper>
  );
};

export default DetailsView;

DetailsView.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  isDisabled: PropTypes.bool,
};
